export default __webpack_public_path__ + "static/media/icon_school.e3a18722.png";